@use "../styles.module.scss";
@use "../../../config/defaults.module.scss" as defaults;

%layoutLoginBase {
  color: #000;

  display: flex;
  align-items: stretch;
  min-height: 100vh;
}

.layoutLogin {
  @extend %layoutLoginBase;
  background: var(--bg-color-purple);
  background-size: cover;
}

.layoutLoginBF {
  @extend %layoutLoginBase;
  background-color: #1e3a5f;
}

.bar {
  // Above the visual, so the bar's shadow falls onto it.
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  // Narrows on smaller screens, so the visual stays wide enough for the highlights.
  width: clamp(400px, 42vw, 560px);
  padding: 48px clamp(32px, 3.6vw, 48px);
  background-color: var(--color-white);
  box-shadow: 4px 0 16px 0 rgba(0, 0, 0, 0.2);

  // The visual is hidden at this width, see .visual.
  @media screen and ( width < 880px ) {
    width: 100%;
    box-shadow: none;
  }

  @media screen and ( max-width: defaults.$mobileBreakpoint ) {
    padding: 24px;
  }

  // iOS Safari zooms into fields with a font size under 16px when they get focus. Important, as the UI library's
  // `.yst-root .yst-text-input` is more specific.
  @media ( pointer: coarse ) {
    input,
    select,
    textarea {
      font-size: 16px !important;
    }
  }

  > footer {
    margin-top: var(--gap);
    font-size: 0.75rem;
  }
}

.content {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  max-width: 400px;
  margin-inline: auto;
}

.visual {
  position: sticky;
  top: 0;
  flex: 1;
  align-self: flex-start;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  container-type: inline-size;

  // Too narrow for the narrowest bar plus the highlights; keep in sync with WIDE_MEDIA_QUERY.
  @media screen and ( width < 880px ) {
    display: none;
  }
}

// Shows until the canvas draws, and in its place without WebGL; the colours match the shader's background.
.visualBackground {
  background:
    radial-gradient(ellipse 55% 60% at 22% 105%, rgba(188, 200, 244, 0.5), transparent),
    linear-gradient(110deg, #5356ed, #60d4d4);
}

.visualCanvas {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
}

.visualContent {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  height: 100%;
  padding: 48px 48px 48px 64px;
  color: var(--color-white);
}

%glassPill {
  padding: 0.5rem 1.25rem;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(8px);
  font-size: 1.125rem;
  line-height: 1.5;
}

.highlights {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2.5rem;
  max-width: 44rem;

  // Too narrow for the headline.
  @container ( max-width: 440px ) {
    display: none;
  }
}

.highlightsBadge {
  @extend %glassPill;
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
}

.highlightsDot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #22c55e;
}

.highlightsTitle {
  max-width: 9em;
  font-size: clamp(2.5rem, 7cqi, 4.5rem);
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: -0.01em;
  text-shadow: 0 2px 24px rgba(0, 0, 0, 0.2);
  text-wrap: balance;
}

.highlightsPills {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 0;
  list-style: none;
}

.highlightsPill {
  @extend %glassPill;
}

